/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-direct-mutation-state */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import FormBuilder from '../helpers/form-builder';
import FormMessage from '../../common/utility/FormMessage';
import FormSpinner from '../../common/utility/FormSpinner';
import * as upgradeAccountActions from '../../../store/actions/upgrade-account-actions';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as basketActions from '../../../store/actions/basket-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import * as upgradeFormHelper from '../helpers/form-helpers/upgrade-form-helper';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import initialState from '../helpers/form-helpers/initial-state';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import { createDate } from '../../utils/date-utils';
import RegisterFormBanner from '../one-club-register/RegisterFormBanner';
import { getFormContainerWideLeftClassList, getModalContentClassListForSSOForm, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { ssoFormTypes } from '../../utils/form-types';
import { hasValue } from '../../../../../general/js/general-helpers';
import { siteConstants } from '../../utils/constants/sites-constants';

class UpgradeToTicketingAccountForm extends Component {
    constructor(props) {
        super(props);
        const { formData } = this.props;
        const { ssoDomain } = formData;

        const mainAddress = upgradeFormHelper.getMainAddress(formData.currentUser);
        const birthDate = upgradeFormHelper.getDateOfBirth(formData.currentUser);

        this.state = {
            ...initialState.upgradeAccountFormState,
            ssoDomain,
            [formConstants.title]: upgradeFormHelper.getTitle(formData.currentUser),
            [formConstants.dateOfBirth]: birthDate ? createDate(birthDate.year, birthDate.month, birthDate.day) : null,
            [formConstants.country]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.country),
            [formConstants.county]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.county),
            [formConstants.state]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.state),
            [formConstants.city]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.city),
            [formConstants.addressLine1]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine1),
            [formConstants.addressLine2]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine2),
            [formConstants.addressLine3]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine3),
            [formConstants.postcode]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.postcode),
            [formConstants.mobilePhone]: upgradeFormHelper.getMobilePhone(formData, formConstants),
            isModalStylingUpdated: false
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();

        this.displayUpgradeToTicketingAccountForm = this.displayUpgradeToTicketingAccountForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleAccountUpgradeSuccess = this.handleAccountUpgradeSuccess.bind(this);
        this.submitUserDetailsData = this.submitUserDetailsData.bind(this);

        this.formReferences = formScrollHelpers.getFormReferences(formData);
    }

    componentDidMount() {
        const { onSignIn, formData } = this.props;

        if (isEmpty(formData)) {
            onSignIn();
        }

        this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormTypes.UpgradeToTicketingAccount);

        this.updateActiveMemberships();

        this.updateAvailableCounties();

        this.updateAvailableStates();
    }

    componentWillReceiveProps(nextProps) {
        const {
            formData,
            isUpgradeSuccessful,
            loading,
            retrievedUserAddress,
            isUserAddressRetrieveSuccessful
        } = nextProps;

        if (hasValue(formData) && !this.state.isModalStylingUpdated) {
            this.state.isModalStylingUpdated = toggleBemClassesForSSOFormModal(this.formReference, nextProps, ssoFormTypes.UpgradeToTicketingAccount);
        }

        if (!loading && isUserAddressRetrieveSuccessful) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
        }

        if (!loading &&
            isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false), this.handleAccountUpgradeSuccess);
            return;
        }

        if (!loading &&
            !isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                });
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.upgradeAccountFormState);
        actions.resetUpgradeAccountFormState();
    }

    updateActiveMemberships() {
        const { onSignIn, formData: { activeMemberships } } = this.props;

        if (isEmpty(activeMemberships)) {
            onSignIn();
        }

        this.setState(formStateHelpers.updateActiveMemberships(activeMemberships));
    }

    updateAvailableCounties() {
        const { formData: { county } } = this.props;
        const receivedCountry = get(this.state, formConstants.country, null);

        this.setState(formStateHelpers.updateAvailableCounties(receivedCountry, county));
    }

    updateAvailableStates() {
        const { formData: { state } } = this.props;
        const receivedCountry = get(this.state, formConstants.country, null);

        this.setState(formStateHelpers.updateAvailableStates(receivedCountry, state));
    }

    handleAccountUpgradeSuccess() {
        const { actions, formData } = this.props;
        const { isFromResale, resaleTickets } = formData;
        if (isFromResale) {
            actions.handleRedirectToResaleTickets(resaleTickets.buyLink, resaleTickets.secutixResaleUrl, resaleTickets.secutixPointOfSaleId, resaleTickets.secutixVirtualOperator);
        } else {
            actions.retryPurchase();
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            formData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitUserDetailsData);
    }

    submitUserDetailsData() {
        const { actions, formData } = this.props;
        const { callBackUrlPut, currentUser, ssoDomain } = formData;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);
        actions.upgradeToTicketingAccount(ssoDomain, this.state, currentUser, callBackUrlPut);
    }

    displayForm() {
        const {
            onSignIn,
            isUpgradeSuccessful,
            accountUpgradeMessages,
            isPaymentAttemptSuccessful,
            purchaseAttemptMessages,
            formData
        } = this.props;

        if (isEmpty(formData)) {
            return null;
        }

        const messagesToDisplay = _isEmpty(accountUpgradeMessages) ? purchaseAttemptMessages : accountUpgradeMessages;
        const isWomensOpen = window.location.hostname.toLowerCase().includes(siteConstants.womensOpen.toLowerCase());

        const isFromResale = formData.isFromResale;
        const footerLinkText = !isFromResale ? `${formMessageConstants.alreadyHaveATicketingAccount} ${formMessageConstants.signInHere}` : '';
        const footerButtonText = !isFromResale ? (isWomensOpen ? formMessageConstants.updateAccount : formMessageConstants.upgradeAccount) : formMessageConstants.upgradeAccountResale;

        return (<Fragment>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={isUpgradeSuccessful && isPaymentAttemptSuccessful}
                    messages={messagesToDisplay}></FormMessage>
                {this.displayUpgradeToTicketingAccountForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    linkCallBackUrl={onSignIn}
                    footerButtonText={footerButtonText}
                    footerLinkText={footerLinkText}
                    useYellowButton={isFromResale}></SSOFormFooter>
            </form>
        </Fragment>
        );
    }

    displayUpgradeToTicketingAccountForm() {
        const { actions, formData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, mobilePhone, state } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        copyOfFormData[formConstants.title].defaultValue = this.state[formConstants.title];

        if (this.state[formConstants.dateOfBirth] !== undefined && this.state[formConstants.dateOfBirth] instanceof Date && !isNaN(this.state[formConstants.dateOfBirth])) {
            if (!copyOfFormData[formConstants.dateOfBirth].defaultValue) {
                copyOfFormData[formConstants.dateOfBirth].defaultValue = this.state[formConstants.dateOfBirth];
            }
        }

        copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
        copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
        copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
        copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
        copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
        copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
        copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
        copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];

        if (this.state[formConstants.mobilePhone]) {
            if (!copyOfFormData[formConstants.mobilePhone].defaultValue) {
                copyOfFormData[formConstants.mobilePhone].defaultValue = {};
                copyOfFormData[formConstants.mobilePhone].defaultValue.selectedCountry = this.state[formConstants.mobilePhone].selectedCountry;
                copyOfFormData[formConstants.mobilePhone].defaultValue.phoneNumber = this.state[formConstants.mobilePhone].phoneNumber;
            }
        }

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),
                    () => {
                        actions.resetRetrievedUserAddress();
                    });
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, formData } = this.props;
        const { formBanner, desktopImageSrc, mobileImageSrc } = formData;

        const isFromResale = formData.isFromResale;
        const headerTitle = !isFromResale ? formMessageConstants.upgradeToTicketingAccount : formMessageConstants.upgradeToTicketingAccountFromResale;

        formBanner.bannerTitle = headerTitle;

        return (
            <div ref={this.formReference} className={getModalContentClassListForSSOForm(this.props)}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    <RegisterFormBanner
                        formBanner={formBanner}
                    ></RegisterFormBanner>
                    <div className='form-container__form'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div>
        );
    }
}

UpgradeToTicketingAccountForm.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    formData: PropTypes.object,
    ssoDomain: PropTypes.string
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUpgradeSuccessful: state.upgradeAccountForm.isUpgradeSuccessful,
        accountUpgradeMessages: state.upgradeAccountForm.accountUpgradeMessages,
        isPaymentAttemptSuccessful: state.basket.isPaymentAttemptSuccessful,
        purchaseAttemptMessages: state.basket.purchaseAttemptMessages,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            upgradeToTicketingAccount: bindActionCreators(upgradeAccountActions.upgradeToTicketingAccount, dispatch),
            resetUpgradeAccountFormState: bindActionCreators(upgradeAccountActions.resetUpgradeAccountFormState, dispatch),
            retryPurchase: bindActionCreators(basketActions.retryPurchase, dispatch),
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch),
            handleRedirectToResaleTickets: bindActionCreators(userAccountActions.handleRedirectToResaleTickets, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpgradeToTicketingAccountForm);
